<template>
  <div class="record-diff">
    {{ cur }}
    <i v-if="isDecrease || isIncrease" :class="['arrow', arrowClass]">{{ diff }}</i>
  </div>
</template>
<script>
export default {
  name: 'RecordDiff',
  props: {
    /** 表格的数据对象 */
    row: { type: Object, required: true },

    /** row[prop] & row.last[prop] */
    prop: { type: String, required: true },
  },

  computed: {
    cur() {
      return Number(this.row[this.prop] || 0)
    },
    last() {
      if (this.row.last === undefined) {
        return this.cur
      }
      return Number(this.row.last[this.prop] || 0)
    },
    diff() {
      return Math.abs(this.cur - this.last)
    },

    // 是增加
    isIncrease() {
      return this.cur > this.last
    },

    // 是减少
    isDecrease() {
      return this.cur < this.last
    },

    // 上下箭头
    arrowClass() {
      return this.isIncrease ? 'up' : this.isDecrease ? 'down' : ''
    },
  },
}
</script>

<style lang="scss" scoped>
.record-diff {
  position: relative;
}
.arrow {
  position: absolute;
  right: 0%;
  font-style: normal;
  font-size: inherit;
  display: inline-block;
  margin-left: 8px;
  // letter-spacing: -3px;
  &.up {
    color: $theme-gold;
    &:after {
      content: "↑";
    }
  }
  &.down {
    color: $theme-green;
    &:after {
      content: "↓";
    }
  }
}
</style>
